import React, { useEffect, useState } from 'react'
import "./xlData.scss";
import axios from 'axios';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const XlData = () => {
  const [correctGuessers, setCorrectGuess] = useState([]);
  const [loading, setLoading] = useState(false);

 // const devApiLink = "http://localhost:4348/api/v1";
 const devApiLink = "https://xl-api.notionspromos.com/api/v1";

  useEffect(() => {
    setLoading(true);
    const userData = async () => {
      try {
        const response = await axios.get(`${devApiLink}/get-xl-user-data`);
        setCorrectGuess(response.data.mergedData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    userData();
  }, []);

  //console.log(correctGuessers);

  const total = correctGuessers.length
  const correctCodeFlavour = correctGuessers
    .map((item) => item.correctCodeFlavour)
    .filter((flavour) => flavour !== null);

  const totalCorrectFlavour = correctCodeFlavour.length


  const wonPrize = correctGuessers
    .map((item) => item.winItemName)
    .filter((item) => item !== null);

  const totalWon = wonPrize.length;

 


  const columns = [
    {
      field: "actualCorrectFlavor",
      headerName: "Actual Flavor",
      width: 150,
    },
    { field: "qr", headerName: "Qr", width: 150 },
    { field: "selectFlavor", headerName: "User Guessed", width: 300 },
    {
      field: "correctCodeFlavour",
      headerName: "Correctly Guessed",
      width: 200,
    },
    {
      field: "userName",
      headerName: "Name",
      width: 150,
    },
    {
      field: "userNationality",
      headerName: "Nationality",
      width: 150,
    },
    {
      field: "userPhone",
      headerName: "Phone",
    },
    {
      field: "userEmail",
      headerName: "Email",
      width: 150,
    },
    {
      field: "userResidence",
      headerName: "Residence",
      width: 150,
    },
    {
      field: "winItemName",
      headerName: "Prizes Won",
      width: 150,
    },
  ];

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="windata_wrp">
          <span>Total Participants : {total}</span>
          <span>Guessed Correctly : {totalCorrectFlavour}</span>
          <span>Total Winners : {totalWon}</span>
        </div>
        <div className="pt_grid">
          {loading ? (
            <div className="loading">
             
              <p>Loading....</p>
            </div>
          ) : (
            <div className="data_gird">
              <DataGrid
                key={correctGuessers._id}
                //onCellClick={handleCellClick}
                rows={correctGuessers}
                columns={columns}
                pageSize={5}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: {
                      // pageSize: 5,
                    },
                  },
                }}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default XlData
